;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import { useGlobalEvent } from '@/lib/hooks/useEvent'

/**
 * Returns a function that accepts a callback to be performed when the window scrolls.
 */
const useWindowScroll = () => useGlobalEvent<UIEvent>('scroll')

export default useWindowScroll
